export const UPDATE_TOPIC_PREFERENCE = 'UPDATE_TOPIC_PREFERENCE'
export const SUBMIT_TOPIC_PREFERENCES = 'SUBMIT_TOPIC_PREFERENCES'
export const ADD_CUSTOM_TOPICS = 'ADD_CUSTOM_TOPICS'

export const FETCH_USER_TOPICS = 'FETCH_USER_TOPICS'
export const FETCH_SUGGESTED_TOPICS = 'FETCH_SUGGESTED_TOPICS'

export const INITIALIZE_FROM_URL = 'INITIALIZE_FROM_URL'

export const URL_HOME = '/topics_preferences'